function buildMenu (allowed) {
  let menu = []
  if (allowed == null || allowed.includes('Dashboards'))  {
    menu = [
      {
        title: 'Dashboards',
        icon: 'mdi-tablet-dashboard',
        items: [
          {
            title: 'Plants', 
            icon: 'mdi-cannabis',
            path: '/DshPlants'
          },
          // {
          //   title: 'Immature Plants', 
          //   icon: 'mdi-sprout',
          //   path: '/DshCultivation'
          // },
          {
            title: 'Harvests', 
            icon: 'mdi-tractor',
            path: '/DshHarvests'
          },

          {
            title: 'Compliance', 
            icon: 'mdi-shield-outline',
            path: '/DshCompliance'
          },
        ]
      }
    ] 
  } 
  return menu
}

export default buildMenu